import axios from 'axios'

const baseUrl = process.env.VUE_APP_API_BACKEND

const getBearer = () => {
  return { Authorization: `Bearer ${localStorage.getItem('token')}` }
}

export default {
  get: (resource) =>
    axios.get(`${baseUrl}${resource}`, {
      headers: {
        ...getBearer(),
      },
    }),
  post: (resource, payload, headers) =>
    axios.post(`${baseUrl}${resource}`, payload, {
      headers: {
        ...headers,
        ...getBearer(),
      },
    }),
  put: (resource, payload) =>
    axios.put(`${baseUrl}${resource}`, payload, {
      headers: {
        ...getBearer(),
      },
    }),
  delete: (resource, payload) =>
    axios.delete(`${baseUrl}${resource}`, {
      headers: {
        ...getBearer(),
      },
      data: payload,
    }),
    resizeImage: (resource, payload) =>
    axios.post(`${baseUrl}${resource}`, payload, {
      headers: {
        'Content-Type': 'multipart/form-data',
        ...getBearer(),
      },
      responseType: 'blob'
    }),
}
